import getEnvVar from 'utils/getEnvVar';

const basePath = getEnvVar('REACT_APP_API');

const config = {
  basePath,
};

export default config;
